import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import MaterialLink from '../material-link';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: theme.spacing(1, 0),
  },
  link: {
    color: '#000',
    fontWeight: 'bold',
  },
}));

const AttendeesSummary = ({ event }) => {
  const { memberSummary } = event;
  const classes = useStyles();

  if (!memberSummary) {
    return null;
  }

  const summaryText = `${memberSummary.GOING.count} Going – ${
    memberSummary.INTERESTED.count} Interested`;
  return (
    <div className={classes.wrapper}>
      {event.permissions.attendeesViewable ? (
        <MaterialLink
          href="/events/[id]/attendees"
          as={`/events/${event.id}/attendees`}
          className={classes.link}
        >
          {summaryText}
        </MaterialLink>
      ) : summaryText}
    </div>
  )
};

AttendeesSummary.propTypes = {
  event: PropTypes.object,
};

export default AttendeesSummary;
